import { FormControl } from '@angular/forms';
import { AllocationViewAllocateType } from '../../constants';
import { AllocationViewTimeslot } from '../allocation-view-timeslot.model';
import { AllocationRuleSelectionModel } from './allocation-action-allocate-rule.model';

export class AllocationTimeslotSelectionModel {
  selectedAllocationType: AllocationViewAllocateType = AllocationViewAllocateType.Manual;
  details: AllocationViewTimeslot | AllocationRuleSelectionModel = null;

  constructor(params?: AllocationTimeslotSelectionModel) {
    if (params) {
      this.selectedAllocationType = params.selectedAllocationType;
      this.details = params.details;
    }
  }
}

export class AllocationTimeslotSelectionFormModel {
  constructor(
    model: AllocationTimeslotSelectionModel,
    public selectedAllocationType: FormControl<AllocationViewAllocateType> = new FormControl(
      model.selectedAllocationType,
    ),
    public details: FormControl<AllocationViewTimeslot | AllocationRuleSelectionModel> = new FormControl(model.details),
  ) {}
}
